import { fileEntitySchema, loadFileFromFileEntity } from "@/hooks/use-upload";
import { api } from "@/libs/api-client";
import type { GenericApiResponse } from "@/types/api-types";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const updateAvatarSchema = z.object({
  avatar: fileEntitySchema,
});

export type UpdateAvatarInput = z.infer<typeof updateAvatarSchema>;

export const updateAvatar = createServerFn({ method: "POST" })
  .validator(updateAvatarSchema)
  .handler(async ({ data }) => {
    const avatarFile = await loadFileFromFileEntity(data.avatar);

    const formData = new FormData();
    formData.append("file", avatarFile);

    const response = await api
      .post("user/updateAvatar", { body: formData })
      .json<GenericApiResponse>();

    return response.ok;
  });
